// @flow
import fp from "lodash/fp"
import { createSelector } from "reselect"

import type { Action } from "./actions"
import type { State } from "booking/services/types"
import { getGroupCombinations } from "./utils/baggageUtils"
import type { Baggage } from "booking/services/baggage/types"

const DEFAULT_STATE: Baggage = {
  definitions: {
    handBag: [],
    holdBag: [],
  },
  combinations: {
    handBag: [],
    holdBag: [],
  },
  original: {
    definitions: {
      hand_bag: [],
      hold_bag: [],
    },
    combinations: {
      hand_bag: [],
      hold_bag: [],
    },
  },
}

const baggageReducer = (state: Baggage = DEFAULT_STATE, action: Action): Baggage => {
  switch (action.type) {
    case "LOAD_SUCCESS_BAGGAGE":
      return action.payload
    default:
      return state
  }
}

// Data selectors
// ===
export const getBaggage = (state: State): Baggage => state.reservation.baggage

export default baggageReducer

// Data selectors
// ===
export const getCombinations: $FlowFixMe = createSelector(
  getBaggage,
  fp.get("combinations"),
)
export const getOriginalBaggage: $FlowFixMe = createSelector(
  getBaggage,
  baggage => baggage.original,
)
export const getHandBagCombinations: $FlowFixMe = createSelector(
  getCombinations,
  combinations => combinations.handBag,
)
export const getHoldBagCombinations: $FlowFixMe = createSelector(
  getCombinations,
  combinations => combinations.holdBag,
)
export const getAdultHandBagCombinations: $FlowFixMe = createSelector(
  getHandBagCombinations,
  getGroupCombinations("adult"),
)
export const getAdultHoldBagCombinations: $FlowFixMe = createSelector(
  getHoldBagCombinations,
  getGroupCombinations("adult"),
)

export const getDefinitions: $FlowFixMe = createSelector(
  getBaggage,
  fp.get("definitions"),
)

export const getHoldBagDefinitions: $FlowFixMe = createSelector(
  getDefinitions,
  fp.get("holdBag"),
)
export const getHandBagDefinitions: $FlowFixMe = createSelector(
  getDefinitions,
  fp.get("handBag"),
)
